import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const ShTenForm = () => {
    const [records, setRecords] = useState(() => {
        const saved = localStorage.getItem("sh10_data");
        return saved ? JSON.parse(saved) : [{
            id: Date.now(),
            header: {},
            transactions: [{ id: Date.now() + 1 }]
        }];
    });
    useEffect(() => {
        localStorage.setItem("sh10_data", JSON.stringify(records));
    }, [records]);

    const updateHeader = (id, field, value) => {
        setRecords(prev => prev.map(rec => 
            rec.id === id ? { ...rec, header: { ...rec.header, [field]: value } } : rec
        ));
    };

    const updateTransaction = (recId, transId, field, value) => {
        setRecords(prev => prev.map(rec => {
            if (rec.id !== recId) return rec;
            return {
                ...rec,
                transactions: rec.transactions.map(t => 
                    t.id === transId ? { ...t, [field]: value } : t
                )
            };
        }));
    };

    const addTransaction = (id) => {
        setRecords(prev => prev.map(rec => 
            rec.id === id ? { ...rec, transactions: [...rec.transactions, { id: Date.now() }] } : rec
        ));
    };

    const addNewFolio = () => {
        setRecords([...records, { id: Date.now(), header: {}, transactions: [{ id: Date.now() + 1 }] }]);
    };

    const handleSave = () => {
  const payload = {
    formType: "SH-10",
    generatedAt: new Date().toISOString(),
    totalFolioRecords: records.length,
    records: records.map(({ id, header, transactions }) => ({
      folioId: id,
      header: {
        compName: header.compName || "",
        office: header.office || "",
        specResDate: header.specResDate || "",
        boardAppDate: header.boardAppDate || "",
        authDetails: header.authDetails || "",
        offerPeriod: header.offerPeriod || "",
        completionDate: header.completionDate || "",
        secDesc: header.secDesc || "",
        signatoryName: header.signatoryName || "",
        designation: header.designation || "",
        place: header.place || "",
        currentDate: header.currentDate || "",
        otherDetails: header.otherDetails || ""
      },
      transactions: transactions.map(({ id, ...t }) => ({
        sno: t.sno || "",
        folioNo: t.folioNo || "",
        holderName: t.holderName || "",
        category: t.category || "",
        buyBackDate: t.buyBackDate || "",
        qty: t.qty || "",
        mode: t.mode || "",
        nominalVal: t.nominalVal || "",
        buyPrice: t.buyPrice || "",
        payDate: t.payDate || "",
        totalPaid: t.totalPaid || "",
        cumTotal: t.cumTotal || "",
        cancelDate: t.cancelDate || "",
        refMem: t.refMem || "",
        remarks: t.remarks || ""
      }))
    }))
  };

  console.log("SH-10 FINAL PAYLOAD", JSON.stringify(payload, null, 2));
};

    return (
        <div>
            <div className="bg-white border-b-2 px-6 py-2 mb-8 text-center shadow-sm">
                <h1 className="text-xl font-bold uppercase">Form No. SH - 10</h1>
                <h2 className="text-lg font-semibold">Register of shares or other securities bought-back</h2>
                <p className="text-[10px] italic text-gray-600 mt-1">
                    [Pursuant to sub-section (9) of section 68 of the Companies Act, 2013 and rule 17 (12) of the Companies (Share Capital and Debentures) Rules 2014]
                </p>
            </div>

            {records.map((record, rIdx) => (
                <div key={record.id} className="bg-white border border-gray-300 rounded-lg shadow-md mb-2 overflow-hidden">
                    <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                        <span className="font-bold text-sm tracking-widest uppercase">Buy-Back Folio #{rIdx + 1}</span>
                        {records.length > 1 && (
                            <button 
                                onClick={() => setRecords(records.filter(r => r.id !== record.id))}
                                className="bg-red-600 hover:bg-red-700 text-[10px] px-3 py-1 rounded font-bold uppercase transition"
                            >
                                Delete Folio
                            </button>
                        )}
                    </div>

                    <div className="p-6 space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField label="Name of Company" value={record.header.compName} onChange={(v) => updateHeader(record.id, 'compName', v)} />
                            <FormField label="Registered office address" type="description" value={record.header.office} onChange={(v) => updateHeader(record.id, 'office', v)} />
                            
                            <FormField label="1. Date of passing special resolution at the meeting of the members authorizing buy-back of securities" type="date" value={record.header.specResDate} onChange={(v) => updateHeader(record.id, 'specResDate', v)} />
                            <FormField label="2. Date of approval by the Board" type="date" value={record.header.boardAppDate} onChange={(v) => updateHeader(record.id, 'boardAppDate', v)} />
                            
                            <FormField label="3. Number, price and amount of shares or other specified securities authorized to be bought back" type="description" value={record.header.authDetails} onChange={(v) => updateHeader(record.id, 'authDetails', v)} />
                            <FormField label="4. Date of opening and closing of buy-back offer" value={record.header.offerPeriod} onChange={(v) => updateHeader(record.id, 'offerPeriod', v)} />
                            
                            <FormField label="5. Date by which buy-back was completed" type="date" value={record.header.completionDate} onChange={(v) => updateHeader(record.id, 'completionDate', v)} />
                            <FormField label="6. Description of shares or other specified securities bought back by the company" type="description" value={record.header.secDesc} onChange={(v) => updateHeader(record.id, 'secDesc', v)} />
                        </div>

                        <div className="border-t-2 border-gray-100 pt-8">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="font-bold text-sm underline uppercase tracking-tight text-slate-700">Ledger Entry (Columns 1-15)</h3>
                                <button 
                                    onClick={() => addTransaction(record.id)}
                                    className="bg-primary hover:bg-blue-700 text-white text-[10px] px-4 py-2 rounded-md font-bold uppercase shadow-sm transition"
                                >
                                    + Add New Transaction
                                </button>
                            </div>

                            {record.transactions.map((trans, tIdx) => (
                                <div key={trans.id} className="mb-2 border border-slate-200 rounded-lg p-6 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 relative">
                                    <div className="col-span-full border-b border-slate-200 pb-2 mb-2 flex justify-between items-center">
                                        <span className="font-black text-[10px] text-slate-400 uppercase">Entry Serial No: {tIdx + 1}</span>
                                        {record.transactions.length > 1 && (
                                            <button onClick={() => updateTransaction(record.id, trans.id, 'delete', true)} className="text-red-400 text-[10px] hover:text-red-600 font-bold uppercase">Remove Entry</button>
                                        )}
                                    </div>

                                    <FormField label="(1) S.No" value={trans.sno} onChange={(v) => updateTransaction(record.id, trans.id, 'sno', v)} />
                                    <FormField label="(2) Folio number / DP Id/ client ID / certificate number" value={trans.folioNo} onChange={(v) => updateTransaction(record.id, trans.id, 'folioNo', v)} />
                                    <FormField label="(3) Name of last holder of securities" value={trans.holderName} onChange={(v) => updateTransaction(record.id, trans.id, 'holderName', v)} />
                                    <FormField label="(4) Category of securities (e.g. Equity, ESOP, etc.)" value={trans.category} onChange={(v) => updateTransaction(record.id, trans.id, 'category', v)} />
                                    <FormField label="(5) Date of buy-back" type="date" value={trans.buyBackDate} onChange={(v) => updateTransaction(record.id, trans.id, 'buyBackDate', v)} />
                                    <FormField label="(6) Number of securities bought-back" type="number" value={trans.qty} onChange={(v) => updateTransaction(record.id, trans.id, 'qty', v)} />
                                    <FormField label="(7) Mode of buy-back" value={trans.mode} onChange={(v) => updateTransaction(record.id, trans.id, 'mode', v)} />
                                    <FormField label="(8) Nominal value of securities" value={trans.nominalVal} onChange={(v) => updateTransaction(record.id, trans.id, 'nominalVal', v)} />
                                    <FormField label="(9) Price at which securities are bought back" value={trans.buyPrice} onChange={(v) => updateTransaction(record.id, trans.id, 'buyPrice', v)} />
                                    <FormField label="(10) Date of payment" type="date" value={trans.payDate} onChange={(v) => updateTransaction(record.id, trans.id, 'payDate', v)} />
                                    <FormField label="(11) Amount paid for bought back securities" value={trans.totalPaid} onChange={(v) => updateTransaction(record.id, trans.id, 'totalPaid', v)} />
                                    <FormField label="(12) Cumulative total of securities bought-back" value={trans.cumTotal} onChange={(v) => updateTransaction(record.id, trans.id, 'cumTotal', v)} />
                                    <FormField label="(13) Date of cancellation / physical destruction" type="date" value={trans.cancelDate} onChange={(v) => updateTransaction(record.id, trans.id, 'cancelDate', v)} />
                                    <FormField label="(14) Reference to entry in Register of members" value={trans.refMem} onChange={(v) => updateTransaction(record.id, trans.id, 'refMem', v)} />
                                    <div className="col-span-1 md:col-span-2">
                                        <FormField label="(15) Remarks" type="description" value={trans.remarks} onChange={(v) => updateTransaction(record.id, trans.id, 'remarks', v)} />
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="border-t-2 border-gray-100 pt-8 grid grid-cols-1 md:grid-cols-1 gap-8">
                                <h4 className="font-bold text-xs uppercase text-slate-500">Authorized Signatory</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <FormField label="Name of the Person" value={record.header.signatoryName} onChange={(v) => updateHeader(record.id, 'signatoryName', v)} />
                                <FormField label="Designation" value={record.header.designation} onChange={(v) => updateHeader(record.id, 'designation', v)} />
                                    <FormField label="Place" value={record.header.place} onChange={(v) => updateHeader(record.id, 'place', v)} />
                                    <FormField label="Date" type="date" value={record.header.currentDate} onChange={(v) => updateHeader(record.id, 'currentDate', v)} />
                            </div>
                            <FormField label="2. Other relevant details, if any" type="description" value={record.header.otherDetails} onChange={(v) => updateHeader(record.id, 'otherDetails', v)} />

                        </div>
                    </div>
                </div>
            ))}

            <Button 
            label='Create New SH-10 Register Record'
                onClick={addNewFolio}
                className="mt-2 mr-2"
            />
            <Button 
            label='Save'
                onClick={handleSave}
                className="mt-2 ml-2"
            />
             
        </div>
    );
};

export default ShTenForm;